var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icon:34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 53",
    d: "M12.1951 20.122C12.1951 15.9125 15.6076 12.5 19.8171 12.5H29.8781C34.0875 12.5 37.5 15.9125 37.5 20.122V30.1829C37.5 34.3924 34.0875 37.8049 29.8781 37.8049H19.8171C15.6076 37.8049 12.1951 34.3924 12.1951 30.1829V20.122Z",
    fill: "#2F5D52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 49",
    filter: "url(#filter0_b_1738_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.57317C0 2.04748 2.04748 0 4.57317 0H18.2927C20.8184 0 22.8659 2.04748 22.8659 4.57317V18.2927C22.8659 20.8184 20.8184 22.8659 18.2927 22.8659H4.57317C2.04748 22.8659 0 20.8184 0 18.2927V4.57317Z",
    fill: "url(#paint0_linear_1738_1534)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 49 (Stroke)",
    filter: "url(#filter1_b_1738_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2927 0.152439H4.57317C2.13167 0.152439 0.152439 2.13167 0.152439 4.57317V18.2927C0.152439 20.7342 2.13167 22.7134 4.57317 22.7134H18.2927C20.7342 22.7134 22.7134 20.7342 22.7134 18.2927V4.57317C22.7134 2.13167 20.7342 0.152439 18.2927 0.152439ZM4.57317 0C2.04748 0 0 2.04748 0 4.57317V18.2927C0 20.8184 2.04748 22.8659 4.57317 22.8659H18.2927C20.8184 22.8659 22.8659 20.8184 22.8659 18.2927V4.57317C22.8659 2.04748 20.8184 0 18.2927 0H4.57317Z",
    fill: "url(#paint1_linear_1738_1534)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2927 0.152439H4.57317C2.13167 0.152439 0.152439 2.13167 0.152439 4.57317V18.2927C0.152439 20.7342 2.13167 22.7134 4.57317 22.7134H18.2927C20.7342 22.7134 22.7134 20.7342 22.7134 18.2927V4.57317C22.7134 2.13167 20.7342 0.152439 18.2927 0.152439ZM4.57317 0C2.04748 0 0 2.04748 0 4.57317V18.2927C0 20.8184 2.04748 22.8659 4.57317 22.8659H18.2927C20.8184 22.8659 22.8659 20.8184 22.8659 18.2927V4.57317C22.8659 2.04748 20.8184 0 18.2927 0H4.57317Z",
    fill: "url(#paint2_radial_1738_1534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 50",
    filter: "url(#filter2_b_1738_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1342 4.57317C27.1342 2.04748 29.1816 0 31.7073 0H45.4268C47.9525 0 50 2.04748 50 4.57317V18.2927C50 20.8184 47.9525 22.8659 45.4268 22.8659H31.7073C29.1816 22.8659 27.1342 20.8184 27.1342 18.2927V4.57317Z",
    fill: "url(#paint3_linear_1738_1534)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 50 (Stroke)",
    filter: "url(#filter3_b_1738_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4268 0.152439H31.7073C29.2658 0.152439 27.2866 2.13167 27.2866 4.57317V18.2927C27.2866 20.7342 29.2658 22.7134 31.7073 22.7134H45.4268C47.8683 22.7134 49.8476 20.7342 49.8476 18.2927V4.57317C49.8476 2.13167 47.8683 0.152439 45.4268 0.152439ZM31.7073 0C29.1816 0 27.1342 2.04748 27.1342 4.57317V18.2927C27.1342 20.8184 29.1816 22.8659 31.7073 22.8659H45.4268C47.9525 22.8659 50 20.8184 50 18.2927V4.57317C50 2.04748 47.9525 0 45.4268 0H31.7073Z",
    fill: "url(#paint4_linear_1738_1534)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4268 0.152439H31.7073C29.2658 0.152439 27.2866 2.13167 27.2866 4.57317V18.2927C27.2866 20.7342 29.2658 22.7134 31.7073 22.7134H45.4268C47.8683 22.7134 49.8476 20.7342 49.8476 18.2927V4.57317C49.8476 2.13167 47.8683 0.152439 45.4268 0.152439ZM31.7073 0C29.1816 0 27.1342 2.04748 27.1342 4.57317V18.2927C27.1342 20.8184 29.1816 22.8659 31.7073 22.8659H45.4268C47.9525 22.8659 50 20.8184 50 18.2927V4.57317C50 2.04748 47.9525 0 45.4268 0H31.7073Z",
    fill: "url(#paint5_radial_1738_1534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 51",
    filter: "url(#filter4_b_1738_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1342 31.707C27.1342 29.1813 29.1816 27.1338 31.7073 27.1338H45.4268C47.9525 27.1338 50 29.1813 50 31.707V45.4265C50 47.9522 47.9525 49.9996 45.4268 49.9996H31.7073C29.1816 49.9996 27.1342 47.9522 27.1342 45.4265V31.707Z",
    fill: "url(#paint6_linear_1738_1534)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 51 (Stroke)",
    filter: "url(#filter5_b_1738_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4268 27.2862H31.7073C29.2658 27.2862 27.2866 29.2655 27.2866 31.707V45.4265C27.2866 47.868 29.2658 49.8472 31.7073 49.8472H45.4268C47.8683 49.8472 49.8476 47.868 49.8476 45.4265V31.707C49.8476 29.2655 47.8683 27.2862 45.4268 27.2862ZM31.7073 27.1338C29.1816 27.1338 27.1342 29.1813 27.1342 31.707V45.4265C27.1342 47.9522 29.1816 49.9996 31.7073 49.9996H45.4268C47.9525 49.9996 50 47.9522 50 45.4265V31.707C50 29.1813 47.9525 27.1338 45.4268 27.1338H31.7073Z",
    fill: "url(#paint7_linear_1738_1534)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4268 27.2862H31.7073C29.2658 27.2862 27.2866 29.2655 27.2866 31.707V45.4265C27.2866 47.868 29.2658 49.8472 31.7073 49.8472H45.4268C47.8683 49.8472 49.8476 47.868 49.8476 45.4265V31.707C49.8476 29.2655 47.8683 27.2862 45.4268 27.2862ZM31.7073 27.1338C29.1816 27.1338 27.1342 29.1813 27.1342 31.707V45.4265C27.1342 47.9522 29.1816 49.9996 31.7073 49.9996H45.4268C47.9525 49.9996 50 47.9522 50 45.4265V31.707C50 29.1813 47.9525 27.1338 45.4268 27.1338H31.7073Z",
    fill: "url(#paint8_radial_1738_1534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 52",
    filter: "url(#filter6_b_1738_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 31.707C0 29.1813 2.04748 27.1338 4.57317 27.1338H18.2927C20.8184 27.1338 22.8659 29.1813 22.8659 31.707V45.4265C22.8659 47.9522 20.8184 49.9996 18.2927 49.9996H4.57317C2.04748 49.9996 0 47.9522 0 45.4265V31.707Z",
    fill: "url(#paint9_linear_1738_1534)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 52 (Stroke)",
    filter: "url(#filter7_b_1738_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2927 27.2862H4.57317C2.13167 27.2862 0.152439 29.2655 0.152439 31.707V45.4265C0.152439 47.868 2.13167 49.8472 4.57317 49.8472H18.2927C20.7342 49.8472 22.7134 47.868 22.7134 45.4265V31.707C22.7134 29.2655 20.7342 27.2862 18.2927 27.2862ZM4.57317 27.1338C2.04748 27.1338 0 29.1813 0 31.707V45.4265C0 47.9522 2.04748 49.9996 4.57317 49.9996H18.2927C20.8184 49.9996 22.8659 47.9522 22.8659 45.4265V31.707C22.8659 29.1813 20.8184 27.1338 18.2927 27.1338H4.57317Z",
    fill: "url(#paint10_linear_1738_1534)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2927 27.2862H4.57317C2.13167 27.2862 0.152439 29.2655 0.152439 31.707V45.4265C0.152439 47.868 2.13167 49.8472 4.57317 49.8472H18.2927C20.7342 49.8472 22.7134 47.868 22.7134 45.4265V31.707C22.7134 29.2655 20.7342 27.2862 18.2927 27.2862ZM4.57317 27.1338C2.04748 27.1338 0 29.1813 0 31.707V45.4265C0 47.9522 2.04748 49.9996 4.57317 49.9996H18.2927C20.8184 49.9996 22.8659 47.9522 22.8659 45.4265V31.707C22.8659 29.1813 20.8184 27.1338 18.2927 27.1338H4.57317Z",
    fill: "url(#paint11_radial_1738_1534)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1738_1534",
    x: -13.7591,
    y: -13.7591,
    width: 50.3841,
    height: 50.3844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.87955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1738_1534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1738_1534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1738_1534",
    x: -13.7591,
    y: -13.7591,
    width: 50.3841,
    height: 50.3844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.87955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1738_1534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1738_1534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_1738_1534",
    x: 13.3751,
    y: -13.7591,
    width: 50.3841,
    height: 50.3844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.87955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1738_1534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1738_1534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_1738_1534",
    x: 13.3751,
    y: -13.7591,
    width: 50.3841,
    height: 50.3844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.87955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1738_1534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1738_1534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_1738_1534",
    x: 13.3751,
    y: 13.3747,
    width: 50.3841,
    height: 50.3844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.87955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1738_1534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1738_1534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_1738_1534",
    x: 13.3751,
    y: 13.3747,
    width: 50.3841,
    height: 50.3844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.87955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1738_1534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1738_1534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_1738_1534",
    x: -13.7591,
    y: 13.3747,
    width: 50.3841,
    height: 50.3844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.87955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1738_1534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1738_1534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_1738_1534",
    x: -13.7591,
    y: 13.3747,
    width: 50.3841,
    height: 50.3844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.87955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1738_1534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1738_1534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1738_1534",
    x1: 2.4469,
    y1: 2.10965,
    x2: 27.1276,
    y2: 14.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176B41",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#389A68",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1738_1534",
    x1: 3.29066,
    y1: -0.816638,
    x2: 24.7236,
    y2: 11.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1738_1534",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.41722 22.1173) rotate(-50.9773) scale(17.9572 29.3621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1738_1534",
    x1: 29.5811,
    y1: 2.10965,
    x2: 54.2617,
    y2: 14.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D284",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#409168",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12472C",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1738_1534",
    x1: 30.4248,
    y1: -0.816638,
    x2: 51.8577,
    y2: 11.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1738_1534",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5514 22.1173) rotate(-50.9773) scale(17.9572 29.3621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1738_1534",
    x1: 29.5811,
    y1: 29.2434,
    x2: 54.2617,
    y2: 42.0228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#2D7B53",
    stopOpacity: 0.823529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186B41",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1738_1534",
    x1: 30.4248,
    y1: 26.3172,
    x2: 51.8577,
    y2: 38.8311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1738_1534",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5514 49.2511) rotate(-50.9773) scale(17.9572 29.3621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1738_1534",
    x1: 2.4469,
    y1: 29.2434,
    x2: 27.1276,
    y2: 42.0228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DAA7B",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#70CD9E",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B675",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1738_1534",
    x1: 3.29066,
    y1: 26.3172,
    x2: 24.7236,
    y2: 38.8311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1738_1534",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.41722 49.2511) rotate(-50.9773) scale(17.9572 29.3621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.9a3d16c0ea9b0cfe2d1e6040b431b892.svg";
export { ForwardRef as ReactComponent };